import React, { useEffect } from 'react';
import './AdBanner.css';

const AdBanner = () => {
   

  return (
    <div >
    
    </div>
  );
};

export default AdBanner; 